<template>
  <layout-content>
    <upload-button slot="top-buttons" @on-success="upload" />

    <filter-component />
    <table-component />
  </layout-content>
</template>

<script>
  import TableComponent from '@pbx/components/media/list/table';
  import FilterComponent from '@pbx/components/media/list/filter';
  import UploadButton from '@pbx/components/media/_fragments/file-upload-button';
  import { mapActions } from 'vuex';

  export default {
    components: {
      TableComponent,
      FilterComponent,
      UploadButton
    },

    data: () => ({
      loading: false
    }),

    methods: {
      ...mapActions('pbx/media/table', ['getAsyncData']),

      upload: function() {
        this.getAsyncData();
      }
    }
  };
</script>

<style lang="scss">
  td {
    .aplayer.zorra-aplayer {
      .aplayer-body {
        height: 15px;
      }
    }
  }
</style>
